import React from 'react';

export interface ReduxFilterableProps {
    filterStyle?: "inline" | "popup"
}

export const ReduxFilterable: React.FunctionComponent<ReduxFilterableProps> = () => null;